module.exports = __webpack_public_path__ + "svg/flags/Holy See (Vatican City State).svg";